require('./bootstrap');
// window.Vue = require('vue').default;
import Vue from 'vue';
Vue.config.devtools = true;
import 'livewire-vue';
window.Vue = Vue;

const axios = require('axios');
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
import Swiper from 'swiper/bundle';
import CategoryMenu from './components/categoryMenu';
import Qty from './components/Qty';
import AddCart from './components/AddCart';
import VueLazyload from 'vue-lazyload';
import TwCitySelector from 'tw-city-selector';
import mbHeader from './components/mbHeader';

Vue.use(VueLazyload);
Vue.use(VueLazyload, {
    preLoad: 1.3,
    attempt: 1,
});

const app = new Vue({
    el: '#app',
    components: {
        CategoryMenu,
        Qty,
        AddCart,
        mbHeader,
    },
    data() {
        return {
            menuIsOpen: '',
            isOpen: false,
        };
    },
    methods: {
        isActive: function (item) {
            if (this.menuIsOpen) {
                return this.menuIsOpen === item;
            }
        },
        setActive: function (item) {
            if (this.menuIsOpen === item) {
                this.menuIsOpen = '';
                document.querySelector('.fixed_body').style.display = 'none';
            } else {
                this.menuIsOpen = item;
                document.querySelector('.fixed_body').style.display = 'block';
            }
        },
        clickOutsideClose() {
            this.menuIsOpen = '';
            document.querySelector('.fixed_body').style.display = 'none';
        },
    },
});

if (document.querySelector('.city-selector-set')) {
    new TwCitySelector({
        el: '.city-selector-set',
        elCounty: '.country', // 在 el 裡查找 element
        elDistrict: '.district', // 在 el 裡查找 element
        elZipcode: '.zipcode', // 在 el 裡查找 element
    });
}

const swiper = new Swiper('.home_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    navigation: {
        nextEl: '.home_swiper_next',
        prevEl: '.home_swiper_prev',
    },
    // pagination: {
    //     el: '.home_pagination',
    //     type: 'bullets',
    //     clickable: 'true',
    // },
    on: {
        beforeInit: function () {
            const swiperImg = document.querySelectorAll('.swiper_main_img');
            if (window.innerWidth > 768) {
                swiperImg.forEach(item => {
                    item.src = item.dataset.pcImg;
                    // console.log(item.dataset.pcImg);
                });
            } else {
                swiperImg.forEach(item => {
                    item.src = item.dataset.mbImg;
                });
            }
        },
    },
});

const pdSwiper = new Swiper('.pd_swiper', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 15,
    speed: 1000,
    centeredSlides: true,
    navigation: {
        nextEl: '.pd_swiper_next',
        prevEl: '.pd_swiper_prev',
    },
    breakpoints: {
        760: {
            slidesPerView: 2.25,
            spaceBetween: 15,
        },
        1260: {
            slidesPerView: 3.25,
            spaceBetween: 15,
        },
    },
});

const galleryThumbs = new Swiper('.gallery_thumbs', {
    spaceBetween: 16,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    // centerInsufficientSlides: true,
    slideToClickedSlide: true,
});

const galleryTop = new Swiper('.gallery_top', {
    spaceBetween: 10,
    thumbs: {
        swiper: galleryThumbs,
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`
            );
            let nextSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`
            );
            let prevSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`
            );
            if (
                nextSlide &&
                !nextSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slideNext();
            } else if (
                prevSlide &&
                !prevSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slidePrev();
            }
        },
    },
});

const otherSwipers = new Swiper('.others_swiper', {
    slidesPerView: 2,
    spaceBetween: 15,
    breakpoints: {
        // when window width is >= 480px
        760: {
            slidesPerView: 4,
            spaceBetween: 20,
        },

        // when window width is >= 640px
        1060: {
            slidesPerView: 6,
            spaceBetween: 10,
        },
    },
    navigation: {
        nextEl: '.others_swiper_next',
        prevEl: '.others_swiper_prev',
    },
    pagination: {
        el: '.other_pagination',
        type: 'fraction',
    },
});

const foodSwipers = new Swiper('.food_swiper', {
    spaceBetween: 20,
    navigation: {
        nextEl: '.food_swiper_next',
        prevEl: '.food_swiper_prev',
    },
    pagination: {
        el: '.food_pagination_pc',
        type: 'fraction',
    },
});

const foodSwipersMobile = new Swiper('.food_swiper_mobile', {
    spaceBetween: 0,
    // navigation: {
    //     nextEl: '.food_swiper_next',
    //     prevEl: '.food_swiper_prev',
    // },
    pagination: {
        el: '.food_pagination_mb',
        type: 'fraction',
    },
});
